module.exports = advancedAds;